import React, { useRef } from 'react';
import { differentials } from '../data/site';
import { useGSAP, gsap, MOTION_OK, revealOnScroll } from '../lib/gsap';

// Título fixo à esquerda (CSS sticky) enquanto os diferenciais passam à direita.
const Differentials = () => {
  const scope = useRef(null);

  useGSAP(() => gsap.matchMedia().add(MOTION_OK, () => revealOnScroll()), { scope });

  return (
    <section id="diferenciais" ref={scope} data-testid="differentials-section" className="bg-raised/80 px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-5">
          <div className="md:sticky md:top-28">
            <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight md:text-5xl" data-reveal>
              Nada de playlist no automático.
            </h2>
            <p className="mt-5 max-w-[40ch] text-lg leading-relaxed text-soft" data-reveal>
              O que muda quando quem toca presta atenção na sua festa.
            </p>
          </div>
        </div>

        <ul className="space-y-12 md:col-span-6 md:col-start-7 md:space-y-16">
          {differentials.map((item) => (
            <li key={item.title} data-reveal>
              <div className="mb-5 h-px w-16 bg-ink/30" aria-hidden="true" />
              <h3 className="font-display text-2xl font-semibold tracking-tight md:text-3xl">{item.title}</h3>
              <p className="mt-3 max-w-[48ch] text-lg leading-relaxed text-soft">{item.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Differentials;
